import { useSearchParams } from "react-router-dom";
import { MapPin, Phone, EnvelopeSimple, Clock, WhatsappLogo } from "@phosphor-icons/react";
import ContactForm from "../components/forms/ContactForm";
import CharterForm from "../components/forms/CharterForm";
import useSEO from "../lib/useSEO";

export default function Contact() {
    useSEO({
        title: "Contact — Windermere Shipping",
        description: "Reach Windermere Shipping in Singapore. Charter desk, operations and corporate inquiries.",
    });
    const [params] = useSearchParams();
    const charterIntent = params.get("intent") === "charter";

    return (
        <>
            <section className="relative pt-36 md:pt-44 pb-20 bg-[#040914] border-b border-white/5">
                <div className="wms-container grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
                    <div className="lg:col-span-7">
                        <span className="wms-overline">Contact — Operations Desk</span>
                        <h1 className="mt-6 font-display font-light text-[clamp(2.4rem,6vw,5rem)] leading-[1.05] tracking-tight">
                            Speak to Singapore.<br />
                            <span className="italic text-[#48CAE4]">Operate the world.</span>
                        </h1>
                    </div>
                    <p className="lg:col-span-5 text-white/60 leading-relaxed">
                        Our charter desk responds within 24 hours. For urgent operational matters please reach our 24/7 line or use WhatsApp.
                    </p>
                </div>
            </section>

            <section className="py-20 md:py-24 bg-[#040914]">
                <div className="wms-container grid grid-cols-1 lg:grid-cols-12 gap-10">
                    <div className="lg:col-span-4 space-y-6">
                        <div className="wms-card p-6">
                            <MapPin size={24} weight="duotone" className="text-[#48CAE4]" />
                            <div className="mt-5 wms-overline">Headquarters</div>
                            <p className="mt-3 text-white/80 leading-relaxed">
                                1 Kim Seng Promenade<br />
                                #16-07/08 Great World City<br />
                                Singapore 237994
                            </p>
                        </div>
                        <div className="wms-card p-6">
                            <Phone size={24} weight="duotone" className="text-[#48CAE4]" />
                            <div className="mt-5 wms-overline">Telephone</div>
                            <a href="tel:+6583373376" className="mt-3 block text-white hover:text-[#48CAE4]" data-testid="contact-phone">+65 8337 3376</a>
                            <a href="https://wa.me/6583373376" target="_blank" rel="noreferrer" data-testid="contact-whatsapp" className="mt-3 inline-flex items-center gap-2 text-sm text-white/60 hover:text-white">
                                <WhatsappLogo size={16} weight="fill" className="text-[#1FAE5C]" /> Chat on WhatsApp
                            </a>
                        </div>
                        <div className="wms-card p-6">
                            <EnvelopeSimple size={24} weight="duotone" className="text-[#48CAE4]" />
                            <div className="mt-5 wms-overline">Email Desks</div>
                            <ul className="mt-3 space-y-1 text-white/80">
                                <li><a className="hover:text-[#48CAE4]" href="mailto:chartering@windermereinland.com">chartering@windermereinland.com</a></li>
                                <li><a className="hover:text-[#48CAE4]" href="mailto:ops@windermereinland.com">ops@windermereinland.com</a></li>
                            </ul>
                        </div>
                        <div className="wms-card p-6">
                            <Clock size={24} weight="duotone" className="text-[#48CAE4]" />
                            <div className="mt-5 wms-overline">Charter Desk Hours</div>
                            <p className="mt-3 text-white/80">24/7 · Singapore Standard Time (SGT, UTC +08:00)</p>
                        </div>
                    </div>

                    <div className="lg:col-span-8 space-y-10">
                        {charterIntent ? <CharterForm /> : <ContactForm />}
                        {!charterIntent && (
                            <div>
                                <CharterForm />
                            </div>
                        )}
                    </div>
                </div>
            </section>

            {/* Map */}
            <section className="bg-[#040914] pb-24" data-testid="contact-map-section">
                <div className="wms-container">
                    <div className="border border-white/10 overflow-hidden aspect-[16/8]">
                        <iframe
                            title="Windermere Shipping HQ"
                            src="https://maps.google.com/maps?q=1%20Kim%20Seng%20Promenade%20Great%20World%20City%20Singapore%20237994&t=&z=16&ie=UTF8&iwloc=&output=embed"
                            className="w-full h-full grayscale-[35%] contrast-110"
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    </div>
                </div>
            </section>
        </>
    );
}
